import { render, staticRenderFns } from "./CameraBox.vue?vue&type=template&id=764f7bfc&scoped=true"
import script from "./CameraBox.vue?vue&type=script&lang=js"
export * from "./CameraBox.vue?vue&type=script&lang=js"
import style0 from "./CameraBox.vue?vue&type=style&index=0&id=764f7bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764f7bfc",
  null
  
)

export default component.exports